import { Box, Card, Toggle } from '@palmetto/palmetto-components';
import { useState, useCallback, useMemo } from 'react';

export function AutoAcceptLeadsCard() {
  const [isActive, setIsActive] = useState(false);

  const handleToggle = useCallback(() => {
    setIsActive((prev) => !prev);
  }, []);

  const statusStyle = useMemo(
    () => ({ color: isActive ? 'var(--color-text-success)' : 'var(--color-text-disabled)' }),
    [isActive],
  );

  return (
    <Card padding="lg">
      <Box direction="row" justifyContent="space-between" alignItems="center">
        <Box flex="auto" margin="0 lg 0 0">
          <h2 className="mb-2 text-2xl font-medium">Auto Accept Leads</h2>
          <p className="m-0">
            {"We'll accept all leads that meet your state preferences. To view your leads, go to Lead Management."}
          </p>
        </Box>
        <Box alignItems="center" childGap="xs">
          <Toggle
            id="auto-accept-leads-toggle"
            label=""
            hideLabel
            isChecked={isActive}
            onChange={handleToggle}
            size="lg"
          />
          <span className="text-xs font-medium" style={statusStyle}>
            {isActive ? 'Active' : 'Inactive'}
          </span>
        </Box>
      </Box>
    </Card>
  );
}
